
// MUTATORS

let fdbCrudUtils = {};

fdbCrudUtils.create = function (entity, tablename, db) {
  if (!Array.isArray(db.collections[tablename])) {
    db.collections[tablename] = []; // create table if not exist
  }
  let new_id = db.counter + 1;
  let new_entity = {
    ...entity,
    id: new_id
  }
  let newDb = {
    ...db,
    counter: new_id
  };
  newDb.collections[tablename].push(new_entity);
  return newDb;
};

fdbCrudUtils.update = function (id, entity, tablename, db) {
  let new_table = db.collections[tablename].map((item) => {
    if (item.id === id) {
      return {
        ...item,
        ...entity,
        id: item.id
      };
    }
    return item;
  });
  let newDb = { ...db };
  newDb.counter++;
  newDb.collections[tablename] = new_table;
  return newDb;
};

fdbCrudUtils.delete_by_id = function (id, tablename, db) {
  let new_table = db.collections[tablename].filter((item) => {
    if (item.id === id) {
      return false; // delete from array
    }
    return true; // stay in array
  });
  let newDb = { ...db };
  newDb.collections[tablename] = new_table;
  newDb.counter++;
  return newDb;
};

fdbCrudUtils.keyval_val_get = function (key, tablename, db) {
  let result;
  db.collections[tablename].forEach((item) => {
    if (item.key === key) {
      result = item.val;
    }
  });
  return result;
};

fdbCrudUtils.keyval_upsert = function (key, val, tablename, db) {
  // only for collections with key and val fields
  let updated = false;
  let new_table = db.collections[tablename].map((item) => {
    if (item.key === key) {
      updated = true;
      return {
        ...item,
        val: val
      };
    }
    return item;
  });
  if (updated === false) {
    new_table.push({
      key,
      val
    });
  }
  let newDb = { ...db };
  newDb.collections[tablename] = new_table;
  return newDb;
};

export { fdbCrudUtils };
